import React, { PropTypes } from 'react';
import ExpandableListItem from 'main/components/activityAudit/expandableListItem';
import ItemNumber from 'main/components/activityAudit/itemNumber';
import {
  Avatar as UserAvatar,
  WithTooltip,
} from '@shoflo-rundown/polymer.legacy';
import HistoryButton from 'main/components/activityAudit/historyButton';
import RestoreButton from 'main/components/activityAudit/restoreButton';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import classNames from 'classnames';
import ItemTimeStamp from 'main/components/activityAudit/itemTimeStamp';

export default React.createClass({
  propTypes: {
    item: PropTypes.object,
    column: PropTypes.object,
    changes: PropTypes.string,
    displayHistoryButton: PropTypes.bool,
    displayRestoreButton: PropTypes.bool,
    onHistoryClick: PropTypes.func,
    onRestoreClick: PropTypes.func,
    onNumberClick: PropTypes.func,
    prefix: PropTypes.string,
  },

  getDefaultProps() {
    return {
      prefix: 'added',
    };
  },

  render() {
    let { item, column, changes, onNumberClick, prefix } = this.props;

    let createdOn = item.get('createdOn');

    let wrapperClasses = 'af-list-item-wrapper',
      actionClasses = 'af-list-item-action-icon',
      //TODO: There may be a problem with thesse styles due to changes in how
      //they are handled.
      itemClasses = classNames('af-list-item', {
        expanded: typeof changes !== 'undefined',
      });

    /**
     * Define Restore and History Buttons
     */
    let restoreButtonNode = this._getRestoreButton();
    let historyButtonNode = this._getHistoryButton();

    if (restoreButtonNode && historyButtonNode)
      actionClasses = 'af-list-item-action-icons';

    return (
      <div className={wrapperClasses}>
        <ItemTimeStamp createdOn={createdOn} />
        <div className={actionClasses}>
          <WithTooltip
            placement="top"
            delay={0}
            tip={TooltipConstants.CSActivityFeedListIcon}
          >
            <span>{historyButtonNode}</span>
          </WithTooltip>
          <WithTooltip
            placement="top"
            delay={0}
            tip={TooltipConstants.CSActivityFeedUndoIcon}
          >
            <span>{restoreButtonNode}</span>
          </WithTooltip>
        </div>
        <div className={itemClasses}>
          <UserAvatar user={item.get('user').toJS()} />
          <ItemNumber onClick={onNumberClick} prefix={prefix} />
          {this._getListItemColumn(column)}
          <ExpandableListItem changes={changes} />
        </div>
      </div>
    );
  },

  _getListItemColumn(column) {
    return (
      <span className="af-list-item-column">
        <span> </span>
        {column}
      </span>
    );
  },

  _getRestoreButton() {
    let { displayRestoreButton, onRestoreClick } = this.props;

    return displayRestoreButton ? (
      <RestoreButton onClick={onRestoreClick} />
    ) : null;
  },

  _getHistoryButton() {
    let { displayHistoryButton, onHistoryClick } = this.props;

    return displayHistoryButton ? (
      <HistoryButton onClick={onHistoryClick} />
    ) : null;
  },
});
